import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BnLoadingService, EntityPagedResult, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnMaskParser } from "@bndes/bndes-ux4/bn-mask/bn-mask-parser";
import { BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Estado } from 'src/app/model/estado.model';
import { JanelaEnvioProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { SolicitacaoHonra, SolicitacaoHonraExportacao } from 'src/app/model/solicitacao-honra.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { SolicitacaoHonraService } from "./solicitacao-honra.service";

@Component({
    selector: 'app-solicitacao-honra-pesquisa',
    templateUrl: './solicitacao-honra-pesquisa.component.html',
    styleUrls: ['./solicitacao-honra-pesquisa.component.scss'],
    standalone: false
})
export class SolicitacaoHonraPesquisaComponent implements OnInit {

  private pesquisaForm: UntypedFormGroup;
  private pesquisado = false; // usado no html
  public esconderPesquisa = true;
  private podeEscolherAgente = false;  // usado no html
  private ehAgenteFinanceiro: boolean = false
  private podeEnviarSH = false; // usado no html
  private valoresPesquisaForm: any;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private estados: Estado[] = [];
  private janelaEnvioAtual: JanelaEnvioProtocolo;
  private cnpjUsuario: string;
  private solicitacoesHonra: SolicitacaoHonra[];
  private solicitacaoHonra: SolicitacaoHonra;
  private solicitacoesExportacao: SolicitacaoHonraExportacao[];
  private atributosPaginacaoComponenteListagem: EntityPagedResult<SolicitacaoHonra>;
  private opcoesPaginacao: number[];
  private parametrosPesquisa:any = {};
  operacao: any;
  private totalObjetosRetornados: number;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: SolicitacaoHonraService,
    private datePipe: DatePipe,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private fileUtils:FileUtilsService,
    protected messageService: MessageChannelService,
    private bnPipeCnpj: BnPipeCnpj) {

      this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
      this.estados = this.activatedRoute.snapshot.data['dominios'].estadosSolicitacaoHonra;
      this.janelaEnvioAtual = this.activatedRoute.snapshot.data['janelaAtual']//resolver
      console.log("Janela atual nao encontrada");
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
      this.buscar(false, true)
  }

  ngOnInit() {
    this.valoresPesquisaForm = undefined;
    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario ? usuario.cnpj : null;
    });

    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.pesquisaForm = this.createReactiveForm();

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeEnviarSH = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];
      this.construirFormulario();
    });
  }

  createReactiveForm(): UntypedFormGroup {

    const f =  this.formBuilder.group({
        agenteFinanceiro: null,
        janela: '',
        idSolicitacaoHonra: [null, [Validators.pattern(/^[0-9]+$/), Validators.minLength(1)]],
        estado:  null,
        sistema:[
            {value: ''},
        ],
        idExternoOperacao:[
            {value: null, disabled: false}, [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]
        ],
        contrato:[
            {value: null, disabled: true},
        ],
    });

    f.get('sistema').valueChanges.subscribe(sist => {
        const contrato = f.get('contrato');
        if (sist === 'CL') {
            contrato.disable();
            contrato.clearValidators();
        } else {
            contrato.enable();
            contrato.setValidators([Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]);
        }
        contrato.updateValueAndValidity();
    });

    return f;
  }

  private construirFormulario() {

    const valoresSessao = sessionStorage.getItem('valoresPesquisaSolicitacaoHonraForm');
    this.valoresPesquisaForm = valoresSessao ? JSON.parse(valoresSessao) : {};

    var agenteDefault: AgenteFinanceiro;
    if (this.podeEscolherAgente) {
        agenteDefault = this.valoresPesquisaForm.agenteFinanceiro ?
            this.agentesFinanceiros.filter(agente => agente.id === this.valoresPesquisaForm.agenteFinanceiro.id)[0]
            : null;
    } else {
        agenteDefault = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
        this.pesquisaForm.get("agenteFinanceiro").disable();
    };

    this.pesquisaForm.patchValue({
      agenteFinanceiro: agenteDefault,
      janela: this?.valoresPesquisaForm?.janela ? moment(this.valoresPesquisaForm.janela).format('MM/YYYY')
      : this.janelaEnvioAtual!=null ? moment(this.janelaEnvioAtual.dataAbertura).format('MM/YYYY') : '',
      idSolicitacaoHonra: this.valoresPesquisaForm.idSolicitacaoHonra ? this.valoresPesquisaForm.idSolicitacaoHonra : null,
      estado: this.valoresPesquisaForm.estado ? this.estados.filter(i => i.id === this.valoresPesquisaForm.estado.id)[0] : null,
      sistema: this.valoresPesquisaForm.sistema ? this.valoresPesquisaForm.sistema : '',
      idExternoOperacao: this.valoresPesquisaForm.idExternoOperacao ? this.valoresPesquisaForm.idExternoOperacao : null,
      contrato: this.valoresPesquisaForm.contrato ? this.valoresPesquisaForm.contrato: null
    });

    this.controlaCamposDesabilitados(this.valoresPesquisaForm);

    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.controlaCamposDesabilitados(novosValores);
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaSolicitacaoHonraForm', JSON.stringify(this.valoresPesquisaForm));
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoHonra>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;
    const params: any = {};

    const agenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (agenteFinanceiro) {
        params.cnpjAgenteFinanceiro = agenteFinanceiro.cnpj;
    }

    const sistema = this.pesquisaForm.get('sistema').value;
    if (sistema) {
      params.sistema = sistema;
    }

    const idExternoOperacao = this.pesquisaForm.get('idExternoOperacao').value;
    if (idExternoOperacao && idExternoOperacao.trim()) {
      params.idExternoOperacao = idExternoOperacao.trim();
    }

    const contrato = this.pesquisaForm.get('contrato').value;
    if (contrato && contrato.trim()) {
      params.contrato = contrato.trim();
    }

    const dataJanela: string[] = this.pesquisaForm.get('janela').value?.toString().split('/');
    if (dataJanela && this.pesquisaForm.get('janela').value && this.pesquisaForm.get('janela').value != 'invalid date') {
      params.nomeJanela = this.datePipe.transform(`${dataJanela[1]}/${dataJanela[0]}`, 'MM/yyyy');
    }

    const idSolicitacaoHonra = this.pesquisaForm.get('idSolicitacaoHonra').value;
    if (idSolicitacaoHonra) {
      params.idSolicitacaoHonra = Number(idSolicitacaoHonra);
    }

    const estado: Estado = this.pesquisaForm.get('estado').value;
    if (estado) {
      params.idEstado = Number(estado.id);
    }
    this.parametrosPesquisa = JSON.parse(JSON.stringify(params));


    if(voltarPagina1){
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.solicitacoesHonra, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.service.getSolicitacoesHonra(params)
      .subscribe(response => {
        this.solicitacoesHonra = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
        this.esconderPesquisa = false;
        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.solicitacoesHonra, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true);
        }
      });
  }

  private controlaCamposDesabilitados(novosValores) {
    if (novosValores.sistema == 'CL') {
      if (!this.pesquisaForm.get('contrato').disabled) {
        if (this.pesquisaForm.get('contrato').value != '') {
          this.pesquisaForm.get('contrato').setValue('');
        }
        this.pesquisaForm.get('contrato').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('contrato').disabled) {
        this.pesquisaForm.get('contrato').enable();
      }
    }

    if (novosValores.sistema == '89' || novosValores.sistema == '15') {
      if (!this.pesquisaForm.get('idExternoOperacao').disabled) {
        if (this.pesquisaForm.get('idExternoOperacao').value != '') {
          this.pesquisaForm.get('idExternoOperacao').setValue('');
        }
        this.pesquisaForm.get('idExternoOperacao').disable();
      }
    }
    else {
      if (this.pesquisaForm.get('idExternoOperacao').disabled) {
        this.pesquisaForm.get('idExternoOperacao').enable();
      }
    }
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {
    this.pesquisado = false;
    if (!this.podeEscolherAgente) {
      this.pesquisaForm.reset({sistema: '', agenteFinanceiro: this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0]});
    } else {
      this.pesquisaForm.reset({sistema: ''});
    }
    this.solicitacoesHonra = [];
  }

  public preparaSolicitacoesExportar() {
    let todasSolicitacoesHonra = undefined;
    let bnMaskParser = new BnMaskParser('CNPJ');

    this.loadingService.bloqueiaTela();

    try {
     this.service.getSolicitacoesExportacao(this.parametrosPesquisa).subscribe(
      (resp) => {
       todasSolicitacoesHonra = resp;
        if (this.ehAgenteFinanceiro) {
          this.exportarSolicitacoesQuandoAgenteFinanceiro(todasSolicitacoesHonra);
        } else {
          this.exportarSolicitacoes(todasSolicitacoesHonra);
        }
      },
      (err) =>{
        console.log(err);
        this.showErroExportar();
        this.loadingService.liberaTela();
      });
    } catch (err){
      console.log(err);
      this.showErroExportar();
      this.loadingService.liberaTela();
    }
  }

  exportarSolicitacoes(solicitacoesSeremExportadas): string {

    let csv = `AGENTE FINANCEIRO; CNPJ DO CLIENTE; RAZÃO SOCIAL DO CLIENTE; ID. SOLICITACAO HONRA; ID. OPERACAO; ID. EXTERNO OPERACAO; SISTEMA/NUMERO CONTRATO;JANELA; PARCELA INICIAL SOLICITADA; DATA DA PARCELA INICIAL A SER HONRADA; VALOR ESTIMADO; ESTADO DA SOLICITAÇÃO HONRA;CESTA-NÚMERO;PROCESSAMENTO-NÚMERO CONTRATO;PROCESSAMENTO-FATURA CRÉDITO LIVRE;PROCESSAMENTO-FATURA REPASSE PARCELAS VENCIDAS;PROCESSAMENTO-FATURA REPASSE PARCELAS VINCENDAS\n`;
    let tmp: string = "";

    solicitacoesSeremExportadas.forEach(solicitacao => {
      tmp += `${Utils.nomeAgentePorCNPJ(solicitacao.cnpjAgenteFinanceiro, this.agentesFinanceiros)};${this.bnPipeCnpj.transform(solicitacao?.cnpjClienteFinal)};${solicitacao.razaoSocialClienteFinal};${solicitacao.id};${solicitacao.idOperacao};${this.normalizaZerosAEsquerda(solicitacao.idOperacaoExterno?.trim())};${solicitacao.contratoRepasse ? solicitacao.sistemaRepasse + '/' + solicitacao.contratoRepasse : ''};${solicitacao.nomeJanela};${this.datePipe.transform(solicitacao.dataParcelaInicialInadimplente, 'dd/MM/yyyy')};${this.datePipe.transform(solicitacao.dataParcelaInicialASerHonrada, 'dd/MM/yyyy')};${Number(solicitacao.valorEstimadoHonra).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${solicitacao.estado.nomeEstado};${solicitacao.cestaNumero || ''};${solicitacao.processamentoNumeroContrato || ''};${solicitacao.processamentoFaturaCreditoLivre || ''};${solicitacao.processamentoFaturaRepasseParcelasVencidas || ''};${solicitacao.processamentoFaturaRepasseParcelasVincendas || ''}\n`;
    })
    csv += tmp;

    this.loadingService.liberaTela();
    this.exportar('SOLICITACOES_HONRA_CSV.csv', csv);

    return csv;

  }
  
  exportarSolicitacoesQuandoAgenteFinanceiro(solicitacoesSeremExportadas): string {

    let csv = `AGENTE FINANCEIRO; CNPJ DO CLIENTE; RAZÃO SOCIAL DO CLIENTE; ID. SOLICITACAO HONRA; ID. OPERACAO; ID. EXTERNO OPERACAO; SISTEMA/NUMERO CONTRATO;JANELA; PARCELA INICIAL SOLICITADA; DATA DA PARCELA INICIAL A SER HONRADA; VALOR ESTIMADO; ESTADO DA SOLICITAÇÃO HONRA;CESTA-NÚMERO\n`;
    let tmp: string = "";

    solicitacoesSeremExportadas.forEach(solicitacao => {
      tmp += `${Utils.nomeAgentePorCNPJ(solicitacao.cnpjAgenteFinanceiro, this.agentesFinanceiros)};${this.bnPipeCnpj.transform(solicitacao?.cnpjClienteFinal)};${solicitacao.razaoSocialClienteFinal};${solicitacao.id};${solicitacao.idOperacao};${this.normalizaZerosAEsquerda(solicitacao.idOperacaoExterno?.trim())};${solicitacao.contratoRepasse ? solicitacao.sistemaRepasse + '/' + solicitacao.contratoRepasse : ''};${solicitacao.nomeJanela};${this.datePipe.transform(solicitacao.dataParcelaInicialInadimplente, 'dd/MM/yyyy')};${this.datePipe.transform(solicitacao.dataParcelaInicialASerHonrada, 'dd/MM/yyyy')};${Number(solicitacao.valorEstimadoHonra).toLocaleString('pt-BR', { minimumFractionDigits: 2 })};${solicitacao.estado.nomeEstado};${solicitacao.cestaNumero || ''}\n`;
    })
    csv += tmp;

    this.loadingService.liberaTela();
    this.exportar('SOLICITACOES_HONRA_CSV.csv', csv);

    return csv;

  }

  exportar(nomeArquivo:string , conteudoCsv:any){
    this.fileUtils.exportarArquivo(nomeArquivo, "\ufeff"+conteudoCsv, FileUtilsService.TEXT_CSV);
  }

  showErroExportar(){
    this.messageService.addMessage({
      title: 'Erro',
      type: 'CRUD_OPERATION',
      level: messageLevel.ERROR,
      message: "Ocorreu um erro ao exportar as solicitações"
  });
  }

  private normalizaZerosAEsquerda(linha:string){
    return Utils.formataZerosAEsquerda(linha);
  }


}
